import TerminalIcon from '@mui/icons-material/Terminal'

const Icon = () => {
  return (
    <TerminalIcon
      htmlColor='rgba(0, 0, 0, 0.54)'
      fontSize='medium'
    />
  )
}

export default Icon
